export default "/images/trail_balance.png?5dd326d522e94d27e312849b4b7d7321";